import { useLocation, useNavigate } from "react-router-dom";
import {
  Dashboard as DashboardIcon,
  People as CustomersIcon,
  Error as ErrorIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import SidebarComponent from "./SidebarComponent";

export default function Sidebar({ isSidebarOpen = false, onClose = () => {} }) {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      title: "Dashboard",
      Icon: DashboardIcon,
      path: "/dashboard",
    },
    {
      title: "Customers",
      Icon: CustomersIcon,
      path: "/customers",
    },
    {
      title: "Error Logs",
      Icon: ErrorIcon,
      path: "/error-logs",
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <>
      {/* Sidebar */}
      <aside
        className={`fixed h-full transition-all duration-300 bg-white border-r border-borderLight shadow-xl z-50 w-64 pt-12 sm:pt-0
          ${
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } sm:translate-x-0
          overflow-hidden
        `}
        aria-label="Sidebar"
      >
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="p-4 border-b border-borderLight">
            <h1 className="font-bold text-xl text-primaryGreen">
              License Server
            </h1>
          </div>

          {/* Menu Items */}
          <div className="flex-1 p-4 space-y-1 overflow-y-auto">
            {menuItems.map((item) => (
              <SidebarComponent
                key={item.path}
                title={item.title}
                Icon={item.Icon}
                path={item.path}
                isActive={location.pathname === item.path}
                collapsed={false}
                onClick={onClose}
              />
            ))}
          </div>

          {/* Logout Button */}
          <div className="p-4 border-t border-borderLight">
            <button
              onClick={() => {
                handleLogout();
                onClose();
              }}
              className="flex items-center p-2 mb-0.5 text-primaryText hover:text-primaryRed rounded-lg hover:bg-secondaryRed w-full justify-start"
            >
              <LogoutIcon className="w-5 h-5" />
              <span className="ms-3 text-sm font-semibold font-sans">
                Logout
              </span>
            </button>
          </div>
        </div>
      </aside>

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 sm:hidden z-40"
          onClick={onClose}
        />
      )}
    </>
  );
}
